import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
      meta: { requiresAuth: false, showFooter: true }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/auth/LoginView.vue'),
      meta: { requiresAuth: false, showFooter: true }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/auth/RegisterView.vue'),
      meta: { requiresAuth: false, showFooter: true }
    },
    {
      path: '/auth/callback',
      name: 'oauth-callback',
      component: () => import('@/views/auth/OAuthCallbackView.vue'),
      meta: { requiresAuth: false, showFooter: false }
    },

    {
      path: '/admin/users',
      name: 'admin-users',
      component: () => import('@/views/admin/UserManagementView.vue'),
      meta: { requiresAuth: true, requiresAdmin: true, showFooter: false }
    },
    {
      path: '/admin/pdf-purchases',
      name: 'admin-pdf-purchases',
      component: () => import('@/views/admin/PdfPurchaseManagementView.vue'),
      meta: { requiresAuth: true, requiresAdmin: true, showFooter: false }
    },
    {
      path: '/admin/template-themes',
      name: 'admin-template-themes',
      component: () => import('@/views/admin/TemplateThemeManagementView.vue'),
      meta: { requiresAuth: true, requiresAdmin: true, showFooter: false }
    },
    {
      path: '/admin/tokens',
      name: 'admin-tokens',
      component: () => import('@/views/admin/TokenManagementView.vue'),
      meta: { requiresAuth: true, requiresAdmin: true, showFooter: false }
    },
    {
      path: '/admin/contact',
      name: 'admin-contact',
      component: () => import('@/views/admin/ContactManagementView.vue'),
      meta: { requiresAuth: true, requiresAdmin: true, showFooter: false }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/DashboardView.vue'),
      meta: { requiresAuth: true, showFooter: true }
    },
    {
      path: '/cv/create',
      name: 'cv-create',
      component: () => import('@/views/cv/CreateCvView.vue'),
      meta: { requiresAuth: true, showFooter: false }
    },
    {
      path: '/cv/create/:cvId',
      name: 'cv-create-with-id',
      component: () => import('@/views/cv/CreateCvView.vue'),
      meta: { requiresAuth: true, showFooter: false }
    },
    {
      path: '/cv/create/:cvId/:templateName/:templateDesc',
      name: 'cv-create-with-template',
      component: () => import('@/views/cv/CreateCvView.vue'),
      meta: { requiresAuth: true, showFooter: false }
    },

    {
      path: '/cv/:id/preview',
      name: 'cv-preview',
      component: () => import('@/views/cv/PreviewCvView.vue'),
      meta: { requiresAuth: true, showFooter: true }
    },
    {
      path: '/templates',
      name: 'templates',
      component: () => import('@/views/TemplatesView.vue'),
      meta: { requiresAuth: false, showFooter: true }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/AboutView.vue'),
      meta: { requiresAuth: false, showFooter: true }
    },
    {
      path: '/template/:id/:templateName/preview',
      name: 'template-preview',
      component: () => import('@/views/PreviewTemplateView.vue'),
      meta: { requiresAuth: false, showFooter: true }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/ProfileView.vue'),
      meta: { requiresAuth: true, showFooter: true }
    },
    {
      path: '/pdf-purchases',
      name: 'pdf-purchases',
      component: () => import('@/views/PdfPurchasesView.vue'),
      meta: { requiresAuth: true, showFooter: true }
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import('@/views/PrivacyPolicyView.vue'),
      meta: { requiresAuth: false, showFooter: true }
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('@/views/TermsView.vue'),
      meta: { requiresAuth: false, showFooter: true }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/views/NotFoundView.vue')
    }
  ]
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresAdmin && authStore.user?.role !== 'admin') {
    next('/dashboard')
  } else if (to.name === 'login' && authStore.isAuthenticated) {
    next('/dashboard')
  } else if (to.name === 'register' && authStore.isAuthenticated) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
